import React, { memo, useCallback, useEffect } from 'react'

import { array, string } from 'prop-types'

import { trackSettingsInteraction } from 'Pods/ThreeDStudio/Services/studioTracker'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import {
  restoreAdvancedSettingsExpanded,
  toggleAdvancedSettingsExpanded,
} from 'Pods/ThreeDStudio/Store/actions/ui'

import AdvancedSettingsContent from './Components/AdvancedSettingsContent/AdvancedSettingsContent'
import AdvancedSettingsTrigger from './Components/AdvancedSettingsTrigger/AdvancedSettingsTrigger'

function AdvancedSettings({ items, forceState = '' }) {
  const isAdvancedSettingsExpanded = useThreeDStudioStore(state => state.ui.isAdvancedSettingsExpanded)
  const isExpanded = (() => {
    if (forceState === 'closed') {
      return false
    }

    if (forceState === 'open') {
      return true
    }

    return isAdvancedSettingsExpanded
  })()

  useEffect(() => {
    restoreAdvancedSettingsExpanded()
  }, [])

  const handleTriggerClick = useCallback(() => {
    trackSettingsInteraction('advanced_settings', isExpanded ? 'collapsed' : 'expanded')
    toggleAdvancedSettingsExpanded()
  }, [isExpanded])

  return (
    <div className="advanced-settings">
      <AdvancedSettingsTrigger isExpanded={isExpanded} onClick={handleTriggerClick} />
      {isExpanded && (
        <AdvancedSettingsContent items={items} />
      )}
    </div>
  )
}

AdvancedSettings.propTypes = {
  items: array.isRequired,
  forceState: string,
}

export default memo(AdvancedSettings)
